<div class="vtf">
  <div class="vtf__title">FILTER BY VESSEL TYPE</div>
  <div class="vtf__chips">
    <button type="button"
            class="vtf__chip"
            *ngFor="let t of availableTypes"
            [class.vtf__chip--off]="!isSelected(t.code)"
            [title]="t.label"
            (click)="toggle(t.code)">
      <span class="vtf__dot" [style.background]="t.color"></span>
      <span class="vtf__label">{{ t.label }}</span>
    </button>
  </div>
</div>
